import getOwnerWindow from './getOwnerWindow';

function getStyles(element) {
  var window = getOwnerWindow(element);
  return window != null ? window.getComputedStyle(element, null) : null;
}

export default getStyles;
//# sourceMappingURL=getStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/getStyles.js
// module id = 204
// module chunks = 0 1